export default __webpack_public_path__ + "static/media/Screenshot 2023-04-11 at 4.25.27 PM.0b1b83f6.png";